export { DwRoutingMessageService } from './routing-message.service';
export { DwRoutingMessageModule } from './routing-message.module';
